import { initializeDB } from '../config/db';
import { PANEL_SHOP_QC_STORE } from '../config/constants';
import axiosInstance from '../axiosInstance';

const panelShopQcService = {
    // IndexedDB operations
    async saveToIndexedDB(formData) {
        const db = await initializeDB();
        const tx = db.transaction(PANEL_SHOP_QC_STORE, 'readwrite');
        const store = tx.objectStore(PANEL_SHOP_QC_STORE);
        
        const dataToSave = {
            ...formData,
            updatedAt: new Date().toISOString()
        };
        
        await store.put(dataToSave);
        await tx.done;
        return dataToSave;
    },

    async getFromIndexedDB(uuid) {
        const db = await initializeDB();
        const tx = db.transaction(PANEL_SHOP_QC_STORE, 'readonly');
        const store = tx.objectStore(PANEL_SHOP_QC_STORE);
        const data = await store.get(uuid);
        await tx.done;
        return data;
    },

    async getAllFromIndexedDB() {
        const db = await initializeDB();
        const tx = db.transaction(PANEL_SHOP_QC_STORE, 'readonly');
        const store = tx.objectStore(PANEL_SHOP_QC_STORE);
        const allData = await store.getAll();
        await tx.done;
        return allData || [];
    },

    async deleteFromIndexedDB(uuid) {
        const db = await initializeDB();
        const tx = db.transaction(PANEL_SHOP_QC_STORE, 'readwrite');
        const store = tx.objectStore(PANEL_SHOP_QC_STORE);
        await store.delete(uuid);
        await tx.done;
    },

    // API operations
    async submit(formData) {
        try {
            const response = await axiosInstance.post('/panel-shop-qc/submit', formData);
            return response.data;
        } catch (error) {
            console.error('Error submitting panel shop qc:', error);
            throw error;
        }
    },

    async getAll() {
        try {
            const response = await axiosInstance.get('/panel-shop-qc');
            return response.data;
        } catch (error) {
            console.error('Error fetching panel shop qc list:', error);
            throw error;
        }
    },

    async getById(id) {
        try {
            const response = await axiosInstance.get(`/panel-shop-qc/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching panel shop qc:', error);
            throw error;
        }
    },

    async update(id, formData) {
        try {
            const response = await axiosInstance.put(`/panel-shop-qc/${id}`, formData);
            return response.data;
        } catch (error) {
            console.error('Error updating panel shop qc:', error);
            throw error;
        }
    },

    async delete(id) {
        try {
            const response = await axiosInstance.delete(`/panel-shop-qc/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting panel shop qc:', error);
            throw error;
        }
    },

    async downloadPdf(id) {
        try {
            const response = await axiosInstance.get(`/panel-shop-qc/${id}/pdf`, {
                responseType: 'blob'
            });
            return response.data;
        } catch (error) {
            console.error('Error downloading pdf:', error);
            throw error;
        }
    }
};

export default panelShopQcService;

